import React, { useEffect, useState } from 'react';
import AuthUser from './AuthUser';
import toast, { Toaster } from 'react-hot-toast';

export default function LoginActivityList() {
    const { http, user } = AuthUser();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterType, setFilterType] = useState('');

    useEffect(() => {
        fetchRows();
    }, [filterType]);

    const fetchRows = async () => {
        setLoading(true);
        try {
            let url = `/login_activities?company_id=${user.company_id}`;
            if (filterType) url += `&actor_type=${filterType}`;
            const response = await http.get(url);
            if (response.data.success) {
                setRows(response.data.data || []);
            } else {
                toast.error(response.data.message || 'Failed to load');
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error loading login activity');
        } finally {
            setLoading(false);
        }
    };

    const typeBadge = (type) => {
        const map = {
            parent: 'bg-success',
            staff: 'bg-info',
            admin: 'bg-primary',
        };
        return map[type] || 'bg-secondary';
    };

    return (
        <>
            <Toaster />
            <div className="container-fluid mt-4 px-4">
                <div className="row mb-4">
                    <div className="col-12 d-flex justify-content-between align-items-start flex-wrap gap-2">
                        <div>
                            <h3 className="mb-1">Login Activity</h3>
                            <p className="text-muted mb-0">
                                Parent, teacher, and admin logins with date & time (IST).
                            </p>
                        </div>
                        <div className="d-flex gap-2">
                            <select
                                className="form-select form-select-sm"
                                style={{ width: 160 }}
                                value={filterType}
                                onChange={(e) => setFilterType(e.target.value)}
                            >
                                <option value="">All roles</option>
                                <option value="parent">Parent</option>
                                <option value="staff">Teacher</option>
                                <option value="admin">Admin</option>
                            </select>
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={fetchRows}
                                disabled={loading}
                            >
                                Refresh
                            </button>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        {loading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border" role="status" />
                            </div>
                        ) : rows.length === 0 ? (
                            <p className="text-muted text-center mb-0 py-4">No login activity yet.</p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Login time (IST)</th>
                                            <th>Role</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Source</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={row.id}>
                                                <td>{index + 1}</td>
                                                <td className="text-nowrap">
                                                    {row.logged_in_at_display || row.logged_in_at}
                                                </td>
                                                <td>
                                                    <span className={`badge ${typeBadge(row.actor_type)}`}>
                                                        {row.role_label || row.actor_type}
                                                    </span>
                                                </td>
                                                <td>{row.name || '—'}</td>
                                                <td>{row.email || '—'}</td>
                                                <td className="text-capitalize">{row.source || '—'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
